import { computed, Injectable, signal, Signal } from '@angular/core';

export type RightSidenavTab = 'chat' | 'tasks';

/**
 * Notifies when the right sidenav (My tasks / Chat drawer) opens or closes.
 * Used by permission badge directive to reposition overlays after layout shift.
 */
@Injectable()
export class RightSidenavStateService {
  private readonly openedState = signal<boolean>(false);

  readonly opened: Signal<boolean> = this.openedState;

  isOpened(): boolean {
    return this.openedState();
  }

  setOpened(opened: boolean): void {
    this.openedState.set(opened);
  }

  private readonly activeTabState = signal<RightSidenavTab | null>(null);

  readonly activeTab: Signal<RightSidenavTab | null> = this.activeTabState;

  /** Whether Allo is what the reader sees in the drawer right now. */
  readonly alloOpen: Signal<boolean> = computed(
    () => this.openedState() && this.activeTabState() === 'chat'
  );

  setActiveTab(tab: RightSidenavTab | null): void {
    this.activeTabState.set(tab);
  }
}
